import { useTranslation } from "react-i18next";

export default function ContactUsButton(props){
        const { t } = useTranslation();
    return(
        <>
        <div id="contact-us-button" onClick={props.showContactsClick}>
            <div>{t('Contact')}</div>
            <div><img src="small-phone.svg"/></div>
            <div><img src="small-mail.svg"/></div>
        </div>
        </>
    )
}